import axios from "axios";
import { useMutation } from "@tanstack/react-query";

import { Keys } from "clients/apis/_keys";
import { Routes } from "clients/apis/_routes";

import { authAtom } from "stores";
import { useSetRecoilState } from "recoil";

import { onEditUserRes } from "./helper";

const requestConfig = {
  headers: {
    "Content-Type": "multipart/form-data",
  },
};

export const editUser = async (data: UserReqT) =>
  await axios({
    method: "POST",
    headers: {
      Accept: "application/json",
      // "Content-Type": "multipart/form-data",
      "Content-Type": "multipart/form-data",
    },
    url: Routes.EDIT_USER,
    data,
  });

export const useEditUser = () => {
  const setAuth = useSetRecoilState(authAtom);

  return useMutation({
    mutationKey: [Keys.EDIT_USER_MUT],
    mutationFn: editUser,
    onSuccess: (res) => onEditUserRes({ user: res.data, setAuth }),
  });
};
